import angular from 'angular';
import {
  loaderService,
  orgDataService,
  reportsDataService,
  reportsSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon,
  viewReport,
} from 'app/components/global';
import directive from './report-instance.directive';
import controller from './report-instance.controller';

import reportInstanceComment from './reportInstanceComment';
import reportInstanceStatus from './reportInstanceStatus';

import selectReportDestinationDialog from '../dialog.selectReportDestinationDialog';
import editReportInstanceCommentDialog from '../../../../../archivedReports';
import editReportStatusDialog from '../../../../../dialog.editReportStatusDialog';
import downloadReport from '../../../../../../global/downloadReport';

export default angular.module('app.components.reports.generatedReports.reportInstance', [
  loaderService,
  orgDataService,
  reportsDataService,
  reportsSharedModelService,
  alerts,
  actionIcon,
  confirmDialog,
  editReportInstanceCommentDialog,
  editReportStatusDialog,
  selectReportDestinationDialog,
  reportInstanceComment,
  reportInstanceStatus,
  viewReport,
  downloadReport
])
  .directive('grReportInstance', directive)
  .controller('GRReportInstanceController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportInstance created');
